import React from 'react';
import { SqlFormatter } from '../components/sql-formatter/SqlFormatter';
import '../components/sql-formatter/SqlFormatter.css';

export const SqlFormatterPage: React.FC = () => {
  return (
    <div className="page-container">
      <SqlFormatter />
    </div>
  );
};
